define('adminColorSelectionsListToolbarView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'adminColorSelectionsEditPopupView',
  'adminColorSelectionsLibrariesPopupView',
  'template!adminColorSelectionsListToolbarView',
  'entities/admin/color_selections'
], function (
  Module,
  App,
  _,
  $,
  Marionette,
  EditPopupView,
  LibrariesPopupView,
  Tpl
) {
  'use strict';

  // Above the colour-selection table: search, new selection, Excel round trip.
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'admin-color-selections-list-toolbar-view',

    ui: {
      search: '.js-search',
      importInput: '.js-import',
      importLabel: '.cs-import',
      importResult: '.js-import-result'
    },

    events: {
      'input @ui.search': 'onSearch',
      'click .js-create': 'onCreate',
      'click .js-export': 'onExport',
      'click .js-libraries': 'onLibraries',
      'change @ui.importInput': 'onImport',
      'click .js-import-close': 'onCloseResult'
    },

    serializeData: function () {
      return {
        search: this.options.tableView.search || '',
        labels: {
          search: _.i18n('admin.colorSelections.search', null, 'Search a code, name or description'),
          create: _.i18n('admin.colorSelections.create', null, 'New selection'),
          libraries: _.i18n('admin.colorSelections.libraries', null, 'Libraries'),
          librariesTitle: _.i18n('admin.colorSelections.librariesTitle', null,
            'Spot libraries and spot colours of your account'),
          'export': _.i18n('admin.colorSelections.export', null, 'Export Excel'),
          exportTitle: _.i18n('admin.colorSelections.exportTitle', null,
            'Every selection with its colours, and the imprint technologies with the selection they offer'),
          'import': _.i18n('admin.colorSelections.import', null, 'Import Excel'),
          importTitle: _.i18n('admin.colorSelections.importTitle', null,
            'Same layout as the export. The selections of the file get exactly its colours; ' +
            'a spot colour unknown in the library given is created for your account from its Hex ' +
            '(the library too). The Techniques sheet sets the links. Nothing is deleted.')
        }
      };
    },

    onSearch: function () {
      var self = this;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        self.options.tableView.setSearch($.trim(self.ui.search.val()));
      }, 300);
    },

    onDestroy: function () {
      clearTimeout(this.searchTimer);
    },

    onCreate: function () {
      var tableView = this.options.tableView;
      EditPopupView.open(null, function () { tableView.reloadAll(); });
    },

    onLibraries: function () {
      var tableView = this.options.tableView;
      // Colours of a library may be in selections: their list reflects edits.
      LibrariesPopupView.open(function () { tableView.reloadAll(); });
    },

    onExport: function () {
      window.open(App.request('colorSelections:export-url'), '_self');
    },

    onImport: function (e) {
      var self = this;
      var input = e.currentTarget;
      var file = input.files && input.files[0];
      if (!file) { return; }
      this.ui.importLabel.addClass('busy');
      this.ui.importResult.removeClass('bad').show().html('<i class="fa fa-spinner fa-spin"></i> ' +
        _.escape(_.i18n('admin.colorSelections.importing', null, 'Importing') + ' ' + file.name + '…'));
      App.request('colorSelections:import', file).done(function (result) {
        if (self.isDestroyed) { return; }
        self.renderResult(result || {});
        self.options.tableView.reloadAll();
      }).fail(function (xhr) {
        if (self.isDestroyed) { return; }
        var reason = xhr && xhr.responseJSON && xhr.responseJSON.error;
        self.ui.importResult.addClass('bad').text(
          _.i18n('admin.colorSelections.importFailed', null, 'The file could not be imported') +
          (reason ? ': ' + reason : '.'));
      }).always(function () {
        self.ui.importLabel.removeClass('busy');
        // The same file again must fire a change.
        input.value = '';
      });
    },

    renderResult: function (r) {
      var parts = [
        '<b>' + (r.selectionsCreated || 0) + '</b> ' + _.i18n('admin.colorSelections.created', null, 'created'),
        '<b>' + (r.selectionsUpdated || 0) + '</b> ' + _.i18n('admin.colorSelections.updated', null, 'updated'),
        '<b>' + (r.colors || 0) + '</b> ' + _.i18n('admin.colorSelections.colorsImported', null, 'colours')
      ];
      if (r.librariesCreated) {
        parts.push('<b>' + r.librariesCreated + '</b> ' +
          _.i18n('admin.colorSelections.librariesCreated', null, 'libraries created for your account'));
      }
      if (r.colorsCreated) {
        parts.push('<b>' + r.colorsCreated + '</b> ' +
          _.i18n('admin.colorSelections.colorsCreated', null, 'spot colours created for your account'));
      }
      if (r.colorsUpdated) {
        parts.push('<b>' + r.colorsUpdated + '</b> ' +
          _.i18n('admin.colorSelections.colorsUpdated', null, 'of your spot colours corrected'));
      }
      if (r.selectionsSkipped) {
        parts.push('<b>' + r.selectionsSkipped + '</b> ' +
          _.i18n('admin.colorSelections.skipped', null, 'skipped (see the errors)'));
      }
      var techniques = (r.techniquesLinked || 0) + (r.techniquesUnlinked || 0) + (r.techniquesUpdated || 0);
      if (techniques) {
        parts.push('<b>' + techniques + '</b> ' +
          _.i18n('admin.colorSelections.techniquesChanged', null, 'imprint technologies changed'));
      }
      var html = '<div class="cs-import-sum"><i class="fa fa-check-circle"></i> ' + parts.join(' · ') +
        '<button type="button" class="cs-x js-import-close">×</button></div>';
      var issues = _.map(r.errors || [], function (x) { return { x: x, cls: 'bad' }; })
        .concat(_.map(r.warnings || [], function (x) { return { x: x, cls: 'warn' }; }));
      if (issues.length) {
        html += '<ul class="cs-import-issues">' + _.map(issues, function (it) {
          return '<li class="' + it.cls + '">' + _.escape(it.x.sheet || '') + ', ' +
            _.i18n('admin.colorSelections.line', null, 'line') + ' ' + it.x.line +
            (it.x.label ? ' (' + _.escape(it.x.label) + ')' : '') + ': ' + _.escape(it.x.message) + '</li>';
        }).join('') + '</ul>';
      }
      this.ui.importResult.removeClass('bad').html(html).show();
    },

    onCloseResult: function () {
      this.ui.importResult.hide().empty();
    }
  });
});

